import { createContext, useContext } from 'react';

// creating a context for easy prop passing.

export const defaultLevelUpAnalyticsContextState = {
  allCohorts: [],
  allGroupByKeys: [],
  allSplitByKeys: [],

  currentState: {
    selectedCohort: null,
    selectedGroupByKey: null,
    selectedSplitByKey: null,
    selectedDateRange: {
      startTS: null,
      endTS: null,
    },
    noData: false,
    errorData: false,
    inProgress: false,
  },

  selectedView: {
    viewId: null,
    expandedRowDetails: {
      headerComponent: null,
      infoObj: null,
    },
  },
};

export const LevelUpAnalyticsContext = createContext(defaultLevelUpAnalyticsContextState);

const useLevelUpAnalytics = () => useContext(LevelUpAnalyticsContext);

export { useLevelUpAnalytics };
